
// src/connects/division-settings-page.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import { getArray } from '../helpers/store'

export const mapStateToProps = (state, ownProps)=> {
  const group = ownProps.group && getArray('group_id', state.groups.items, ownProps.group.group_id) || undefined
  
  return {
    isPhone: state.media.isPhone,
    group: group,
    name: state.divisionSettings.name,
    active: state.divisionSettings.active,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    onClose: ()=> dispatch(actions.closeDivisionSettingsPage()),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/division-settings-page.js